
import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import { APPLICATION } from "@/store/applications";
import { IApplicationState } from "@/store/applications/types";
const { mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);

export default Vue.extend({
  computed: {
    ...mapState({
      ifcsAccountNumber: (state: IApplicationState) =>
        state.applicationData && state.applicationData.ifcsAccountNumber,
      jdeAccountNumber: (state: IApplicationState) =>
        state.applicationData && state.applicationData.jdeAccountNumber
    })
  }
});
